function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["__scopeCheckbox", "name", "checked", "defaultChecked", "required", "disabled", "value", "onCheckedChange"],
  _excluded2 = ["__scopeCheckbox", "forceMount"],
  _excluded3 = ["control", "checked", "bubbles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var $dKOox$babelruntimehelpersextends = require("@babel/runtime/helpers/extends");
var $dKOox$react = require("react");
var $dKOox$radixuireactcomposerefs = require("@radix-ui/react-compose-refs");
var $dKOox$radixuireactcontext = require("@radix-ui/react-context");
var $dKOox$radixuiprimitive = require("@radix-ui/primitive");
var $dKOox$radixuireactusecontrollablestate = require("@radix-ui/react-use-controllable-state");
var $dKOox$radixuireactuseprevious = require("@radix-ui/react-use-previous");
var $dKOox$radixuireactusesize = require("@radix-ui/react-use-size");
var $dKOox$radixuireactpresence = require("@radix-ui/react-presence");
var $dKOox$radixuireactprimitive = require("@radix-ui/react-primitive");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createCheckboxScope", function () {
  return $a17f2c9fbf2ccf8c$export$b566c4ff5488ea01;
});
$parcel$export(module.exports, "Checkbox", function () {
  return $a17f2c9fbf2ccf8c$export$48513f6b9f8ce62d;
});
$parcel$export(module.exports, "CheckboxIndicator", function () {
  return $a17f2c9fbf2ccf8c$export$59aad738f51d1c05;
});
$parcel$export(module.exports, "Root", function () {
  return $a17f2c9fbf2ccf8c$export$be92b6f5f03c0fe9;
});
$parcel$export(module.exports, "Indicator", function () {
  return $a17f2c9fbf2ccf8c$export$adb584737d712b70;
});

/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/
var $a17f2c9fbf2ccf8c$var$CHECKBOX_NAME = 'Checkbox';
var _$dKOox$radixuireactc = $dKOox$radixuireactcontext.createContextScope($a17f2c9fbf2ccf8c$var$CHECKBOX_NAME),
  _$dKOox$radixuireactc2 = _slicedToArray(_$dKOox$radixuireactc, 2),
  $a17f2c9fbf2ccf8c$var$createCheckboxContext = _$dKOox$radixuireactc2[0],
  $a17f2c9fbf2ccf8c$export$b566c4ff5488ea01 = _$dKOox$radixuireactc2[1];
var _$a17f2c9fbf2ccf8c$va = $a17f2c9fbf2ccf8c$var$createCheckboxContext($a17f2c9fbf2ccf8c$var$CHECKBOX_NAME),
  _$a17f2c9fbf2ccf8c$va2 = _slicedToArray(_$a17f2c9fbf2ccf8c$va, 2),
  $a17f2c9fbf2ccf8c$var$CheckboxProvider = _$a17f2c9fbf2ccf8c$va2[0],
  $a17f2c9fbf2ccf8c$var$useCheckboxContext = _$a17f2c9fbf2ccf8c$va2[1];
var $a17f2c9fbf2ccf8c$export$48513f6b9f8ce62d = /*#__PURE__*/$dKOox$react.forwardRef(function (props, forwardedRef) {
  var __scopeCheckbox = props.__scopeCheckbox,
    name = props.name,
    checkedProp = props.checked,
    defaultChecked = props.defaultChecked,
    required = props.required,
    disabled = props.disabled,
    _props$value = props.value,
    value = _props$value === void 0 ? 'on' : _props$value,
    onCheckedChange = props.onCheckedChange,
    checkboxProps = _objectWithoutProperties(props, _excluded);
  var _$dKOox$react$useStat = $dKOox$react.useState(null),
    _$dKOox$react$useStat2 = _slicedToArray(_$dKOox$react$useStat, 2),
    button = _$dKOox$react$useStat2[0],
    setButton = _$dKOox$react$useStat2[1];
  var composedRefs = $dKOox$radixuireactcomposerefs.useComposedRefs(forwardedRef, function (node) {
    return setButton(node);
  });
  var hasConsumerStoppedPropagationRef = $dKOox$react.useRef(false); // We set this to true by default so that events bubble to forms without JS (SSR)
  var isFormControl = button ? Boolean(button.closest('form')) : true;
  var _$dKOox$radixuireactu = $dKOox$radixuireactusecontrollablestate.useControllableState({
      prop: checkedProp,
      defaultProp: defaultChecked,
      onChange: onCheckedChange
    }),
    _$dKOox$radixuireactu2 = _slicedToArray(_$dKOox$radixuireactu, 2),
    _$dKOox$radixuireactu3 = _$dKOox$radixuireactu2[0],
    checked = _$dKOox$radixuireactu3 === void 0 ? false : _$dKOox$radixuireactu3,
    setChecked = _$dKOox$radixuireactu2[1];
  var initialCheckedStateRef = $dKOox$react.useRef(checked);
  $dKOox$react.useEffect(function () {
    var form = button === null || button === void 0 ? void 0 : button.form;
    if (form) {
      var reset = function reset() {
        return setChecked(initialCheckedStateRef.current);
      };
      form.addEventListener('reset', reset);
      return function () {
        return form.removeEventListener('reset', reset);
      };
    }
  }, [button, setChecked]);
  return /*#__PURE__*/$dKOox$react.createElement($a17f2c9fbf2ccf8c$var$CheckboxProvider, {
    scope: __scopeCheckbox,
    state: checked,
    disabled: disabled
  }, /*#__PURE__*/$dKOox$react.createElement($dKOox$radixuireactprimitive.Primitive.button, $parcel$interopDefault($dKOox$babelruntimehelpersextends)({
    type: "button",
    role: "checkbox",
    "aria-checked": $a17f2c9fbf2ccf8c$var$isIndeterminate(checked) ? 'mixed' : checked,
    "aria-required": required,
    "data-state": $a17f2c9fbf2ccf8c$var$getState(checked),
    "data-disabled": disabled ? '' : undefined,
    disabled: disabled,
    value: value
  }, checkboxProps, {
    ref: composedRefs,
    onKeyDown: $dKOox$radixuiprimitive.composeEventHandlers(props.onKeyDown, function (event) {
      // According to WAI ARIA, Checkboxes don't activate on enter keypress
      if (event.key === 'Enter') event.preventDefault();
    }),
    onClick: $dKOox$radixuiprimitive.composeEventHandlers(props.onClick, function (event) {
      setChecked(function (prevChecked) {
        return $a17f2c9fbf2ccf8c$var$isIndeterminate(prevChecked) ? true : !prevChecked;
      });
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
        // one click event (from the input). We propagate changes from an input so that native
        // form validation works and form events reflect checkbox updates.
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /*#__PURE__*/$dKOox$react.createElement($a17f2c9fbf2ccf8c$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name: name,
    value: value,
    checked: checked,
    required: required,
    disabled: disabled // We transform because the input is absolutely positioned but we have
    ,

    style: {
      transform: 'translateX(-100%)'
    }
  }));
});
/*#__PURE__*/
Object.assign($a17f2c9fbf2ccf8c$export$48513f6b9f8ce62d, {
  displayName: $a17f2c9fbf2ccf8c$var$CHECKBOX_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/
var $a17f2c9fbf2ccf8c$var$INDICATOR_NAME = 'CheckboxIndicator';
var $a17f2c9fbf2ccf8c$export$59aad738f51d1c05 = /*#__PURE__*/$dKOox$react.forwardRef(function (props, forwardedRef) {
  var __scopeCheckbox = props.__scopeCheckbox,
    forceMount = props.forceMount,
    indicatorProps = _objectWithoutProperties(props, _excluded2);
  var context = $a17f2c9fbf2ccf8c$var$useCheckboxContext($a17f2c9fbf2ccf8c$var$INDICATOR_NAME, __scopeCheckbox);
  return /*#__PURE__*/$dKOox$react.createElement($dKOox$radixuireactpresence.Presence, {
    present: forceMount || $a17f2c9fbf2ccf8c$var$isIndeterminate(context.state) || context.state === true
  }, /*#__PURE__*/$dKOox$react.createElement($dKOox$radixuireactprimitive.Primitive.span, $parcel$interopDefault($dKOox$babelruntimehelpersextends)({
    "data-state": $a17f2c9fbf2ccf8c$var$getState(context.state),
    "data-disabled": context.disabled ? '' : undefined
  }, indicatorProps, {
    ref: forwardedRef,
    style: _objectSpread({
      pointerEvents: 'none'
    }, props.style)
  })));
});
/*#__PURE__*/
Object.assign($a17f2c9fbf2ccf8c$export$59aad738f51d1c05, {
  displayName: $a17f2c9fbf2ccf8c$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */
var $a17f2c9fbf2ccf8c$var$BubbleInput = function $a17f2c9fbf2ccf8c$var$BubbleInput(props) {
  var control = props.control,
    checked = props.checked,
    _props$bubbles = props.bubbles,
    bubbles = _props$bubbles === void 0 ? true : _props$bubbles,
    inputProps = _objectWithoutProperties(props, _excluded3);
  var ref = $dKOox$react.useRef(null);
  var prevChecked = $dKOox$radixuireactuseprevious.usePrevious(checked);
  var controlSize = $dKOox$radixuireactusesize.useSize(control); // Bubble checked change to parents (e.g form change event)
  $dKOox$react.useEffect(function () {
    var input = ref.current;
    var inputProto = window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
    var setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      var event = new Event('click', {
        bubbles: bubbles
      });
      input.indeterminate = $a17f2c9fbf2ccf8c$var$isIndeterminate(checked);
      setChecked.call(input, $a17f2c9fbf2ccf8c$var$isIndeterminate(checked) ? false : checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /*#__PURE__*/$dKOox$react.createElement("input", $parcel$interopDefault($dKOox$babelruntimehelpersextends)({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: $a17f2c9fbf2ccf8c$var$isIndeterminate(checked) ? false : checked
  }, inputProps, {
    tabIndex: -1,
    ref: ref,
    style: _objectSpread(_objectSpread(_objectSpread({}, props.style), controlSize), {}, {
      position: 'absolute',
      pointerEvents: 'none',
      opacity: 0,
      margin: 0
    })
  }));
};
function $a17f2c9fbf2ccf8c$var$isIndeterminate(checked) {
  return checked === 'indeterminate';
}
function $a17f2c9fbf2ccf8c$var$getState(checked) {
  return $a17f2c9fbf2ccf8c$var$isIndeterminate(checked) ? 'indeterminate' : checked ? 'checked' : 'unchecked';
}
var $a17f2c9fbf2ccf8c$export$be92b6f5f03c0fe9 = $a17f2c9fbf2ccf8c$export$48513f6b9f8ce62d;
var $a17f2c9fbf2ccf8c$export$adb584737d712b70 = $a17f2c9fbf2ccf8c$export$59aad738f51d1c05;